import { PATH_DASHBOARD } from 'src/routes/paths';

export const ADMIN_IMPERSONATION_STORAGE_KEY = 'admin_impersonate';

// Set when a super admin opened this session on a white-label dashboard via a
// one-time link. There is no admin session on this origin to return to:
// exiting ends the session and closes the tab.
export const ADMIN_IMPERSONATION_HANDOFF_MODE = 'handoff';

export const isHandoffImpersonation = (impersonation) =>
  impersonation?.mode === ADMIN_IMPERSONATION_HANDOFF_MODE;

export const getAdminImpersonationReturnPath = () => {
  if (typeof window === 'undefined' || !window.location) {
    return PATH_DASHBOARD.admin.overview;
  }

  const { pathname = '', search = '', hash = '' } = window.location;
  const returnPath = `${pathname}${search}${hash}`;

  return returnPath || PATH_DASHBOARD.admin.overview;
};

export const getAdminImpersonation = () => {
  try {
    const raw = localStorage.getItem(ADMIN_IMPERSONATION_STORAGE_KEY);
    if (!raw) return null;

    return JSON.parse(raw);
  } catch {
    return null;
  }
};

export const setAdminImpersonation = (value) => {
  localStorage.setItem(ADMIN_IMPERSONATION_STORAGE_KEY, JSON.stringify(value));
};

export const clearAdminImpersonation = () => {
  localStorage.removeItem(ADMIN_IMPERSONATION_STORAGE_KEY);
};

export const isOwnerImpersonating = () => {
  return Boolean(getAdminImpersonation());
};

export default isOwnerImpersonating;
